import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Icon } from '../../../core/models/icon.model';
import { IconComponent } from '../icon/icon.component';
import { LoadingComponent } from '../loading/loading.component';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-card-wrapper',
  standalone: true,
  imports: [CommonModule, IconComponent, LoadingComponent, I18nPipe],
  templateUrl: './card-wrapper.component.html',
  styleUrl: './card-wrapper.component.scss'
})
export class CardWrapperComponent implements OnInit, OnChanges {
  @Input() icon?: Icon;
  @Input() title!: string;

  @Input() showCheck?: boolean = true;
  @Input() loading?: boolean = false;
  @Input() loadingText?: string = '';
  @Input() initiallyOpen?: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() variant: 'accordion' | 'default' = 'accordion';

  @Input() description?: string;
  @Input() iconColor: string = '#DA291C';
  @Input() iconBackground: string = '#FEF2F2';
  @Input() iconSize: 'sm' | 'md' | 'lg' = 'md';
  @Input() hideHeader: boolean = false;

  public isOpenAccordion: boolean = false;
  
  ngOnInit() {
    this.isOpenAccordion = this.initiallyOpen || false;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      if (this.disabled && this.isOpenAccordion) {
        this.isOpenAccordion = false;
      } else if (!this.disabled && this.initiallyOpen) {
        this.isOpenAccordion = true;
      }
    }
    
    if (changes['initiallyOpen']) {
      this.isOpenAccordion = this.initiallyOpen || false;
    }
  }
  
  toggle() {
    if (!this.disabled) {
      this.isOpenAccordion = !this.isOpenAccordion;
    }
  }
}
